import http from "./constants/http";
import resources from "./constants/resources";

export const smallPackagingAPI = async (body) => {
  const res = await http(resources.SMALLPACKAGING).post(body);
  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};

export const smallPackagingFileAPI = async (body) => {
  const res = await http(resources.SMALLPACKAGING).postFiles(body);
  return res;
};
